// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.renter.v1.CappsRenterUserStatusesWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { GetUserStatusesWebApiResponseDto } from '../..';

export const CappsRenterUserStatusesWebApiHandler_getUserStatuses_Path =
  '/api/web/renter/v1/userStatuses/getUserStatuses';

export const CappsRenterUserStatusesWebApiHandler_getUserStatuses = (client = getClient()) => {
  return httpFrontEndRequest<never, never, GetUserStatusesWebApiResponseDto>(
    {
      endpoint: CappsRenterUserStatusesWebApiHandler_getUserStatuses_Path,
      method: 'GET',
      contextPath: '/capps',
    },
    client,
  );
};
